/* eslint-disable */
import React from "react";
import { supabase } from "./supabaseClient";

const C = {
  primary:"#1a6b3c", primaryPale:"#e8f5ee", primaryMid:"#6ee7b7",
  amber:"#d97706",   amberPale:"#fffbeb",   amberMid:"#fde68a",
  rose:"#e11d48",    rosePale:"#fef2f2",
  blue:"#2563eb",    bluePale:"#eff6ff",
  purple:"#7c3aed",  purplePale:"#f5f3ff",
  text:"#111827",    muted:"#6b7280",       border:"#d1fae5",
  white:"#ffffff",   bg:"#f9fafb",          shadow:"rgba(0,0,0,0.06)",
};

const DEFAULT_LOAN_DAYS = 14;

const todayStr = () => new Date().toISOString().split("T")[0];
const fmt = d => d ? new Date(d).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"}) : "—";
const addDays = (dateStr, n) => { const d = new Date(dateStr+"T00:00:00"); d.setDate(d.getDate()+n); return d.toISOString().split("T")[0]; };
const isOverdue = (issue) => issue.status==="issued" && issue.due_date && issue.due_date < todayStr();

function Toast({ toast }) {
  if (!toast) return null;
  return (
    <div style={{position:"fixed",top:20,right:20,zIndex:9999,background:toast.ok?"#f0fdf4":"#fef2f2",color:toast.ok?"#16a34a":"#dc2626",border:`1px solid ${toast.ok?"#bbf7d0":"#fecaca"}`,borderRadius:10,padding:"10px 18px",fontWeight:700,fontSize:13,boxShadow:"0 4px 18px rgba(0,0,0,.15)"}}>
      {toast.msg}
    </div>
  );
}

function StatCard({ icon, label, val, col, bg }) {
  return (
    <div style={{background:bg,borderRadius:10,padding:"8px 14px",display:"flex",alignItems:"center",gap:9,border:`1px solid ${col}20`}}>
      <span style={{fontSize:18}}>{icon}</span>
      <div>
        <div style={{fontWeight:900,fontSize:20,color:col,lineHeight:1}}>{val}</div>
        <div style={{fontSize:10,color:C.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:.3}}>{label}</div>
      </div>
    </div>
  );
}

const inp = {padding:"8px 10px",borderRadius:7,border:`1px solid ${C.border}`,fontSize:12,boxSizing:"border-box"};
const btn = (bg,color="white") => ({background:bg,color,border:"none",borderRadius:7,padding:"8px 16px",fontSize:12,fontWeight:700,cursor:"pointer"});
const ghostBtn = {background:"none",border:`1px solid ${C.border}`,borderRadius:7,padding:"8px 16px",fontSize:12,fontWeight:700,cursor:"pointer"};

// ── Add / edit book form ───────────────────────────────────────────────────
function BookForm({ initial, onSave, onCancel }) {
  const [form, setForm] = React.useState({
    title: initial?.title||"", author: initial?.author||"", category: initial?.category||"",
    isbn: initial?.isbn||"", total_copies: initial?.total_copies||1, shelf_location: initial?.shelf_location||"",
  });
  const set = (k,v) => setForm(p=>({...p,[k]:v}));
  return (
    <div style={{background:C.white,borderRadius:12,border:`1px solid ${C.border}`,padding:16,display:"flex",flexDirection:"column",gap:10}}>
      <div style={{fontWeight:800,fontSize:14,color:C.text}}>{initial ? "Edit Book" : "Add Book to Catalog"}</div>
      <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
        <input placeholder="Title" value={form.title} onChange={e=>set("title",e.target.value)} style={{...inp,flex:2,minWidth:180}}/>
        <input placeholder="Author" value={form.author} onChange={e=>set("author",e.target.value)} style={{...inp,flex:1,minWidth:140}}/>
      </div>
      <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
        <input placeholder="Category (e.g. Fiction, Science)" value={form.category} onChange={e=>set("category",e.target.value)} style={{...inp,flex:1,minWidth:140}}/>
        <input placeholder="ISBN (optional)" value={form.isbn} onChange={e=>set("isbn",e.target.value)} style={{...inp,flex:1,minWidth:120}}/>
        <input placeholder="Shelf location" value={form.shelf_location} onChange={e=>set("shelf_location",e.target.value)} style={{...inp,flex:1,minWidth:120}}/>
        <input type="number" min={1} placeholder="Copies" value={form.total_copies} onChange={e=>set("total_copies",Number(e.target.value)||1)} style={{...inp,width:90}}/>
      </div>
      <div style={{display:"flex",justifyContent:"flex-end",gap:8}}>
        <button onClick={onCancel} style={ghostBtn}>Cancel</button>
        <button onClick={()=>{ if(!form.title.trim()) return; onSave(form); }} disabled={!form.title.trim()}
          style={btn(form.title.trim()?C.primary:"#9ca3af")}>
          {initial ? "Save Changes" : "+ Add Book"}
        </button>
      </div>
    </div>
  );
}

// ── Catalog tab ───────────────────────────────────────────────────────────
function CatalogTab({ books, onAdd, onUpdate, onToggleActive }) {
  const [showAdd, setShowAdd] = React.useState(false);
  const [editingId, setEditingId] = React.useState(null);
  const [search, setSearch] = React.useState("");
  const [categoryFilter, setCategoryFilter] = React.useState("all");

  const categories = [...new Set(books.map(b=>b.category).filter(Boolean))].sort();
  const filtered = books.filter(b =>
    (categoryFilter==="all" || b.category===categoryFilter) &&
    (!search.trim() || [b.title,b.author,b.isbn].filter(Boolean).some(s=>s.toLowerCase().includes(search.toLowerCase())))
  );

  return (
    <div style={{display:"flex",flexDirection:"column",gap:12}}>
      <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center",justifyContent:"space-between"}}>
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          <input placeholder="🔎 Search title / author / ISBN" value={search} onChange={e=>setSearch(e.target.value)} style={{...inp,minWidth:220}}/>
          <select value={categoryFilter} onChange={e=>setCategoryFilter(e.target.value)} style={inp}>
            <option value="all">All categories</option>
            {categories.map(c=><option key={c} value={c}>{c}</option>)}
          </select>
        </div>
        {!showAdd && <button onClick={()=>setShowAdd(true)} style={btn(C.primary)}>+ Add Book</button>}
      </div>

      {showAdd && <BookForm onSave={(form)=>{ onAdd(form); setShowAdd(false); }} onCancel={()=>setShowAdd(false)}/>}

      {filtered.length===0 && (
        <div style={{background:C.white,borderRadius:12,padding:30,textAlign:"center",color:C.muted,fontSize:13,border:`1px solid ${C.border}`}}>
          No books match.
        </div>
      )}

      {filtered.map(book => editingId===book.id ? (
        <BookForm key={book.id} initial={book}
          onSave={(form)=>{ onUpdate(book.id,form); setEditingId(null); }}
          onCancel={()=>setEditingId(null)}/>
      ) : (
        <div key={book.id} style={{background:C.white,borderRadius:12,border:`1px solid ${C.border}`,padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,flexWrap:"wrap",opacity:book.is_active?1:0.55}}>
          <div>
            <div style={{fontWeight:800,fontSize:14,color:C.text}}>{book.title} {!book.is_active && <span style={{fontSize:11,color:C.muted}}>(inactive)</span>}</div>
            <div style={{fontSize:11,color:C.muted}}>{book.author||"Unknown author"} · {book.category||"Uncategorised"} {book.shelf_location && `· Shelf ${book.shelf_location}`}</div>
          </div>
          <div style={{display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
            <span style={{background:book.available_copies>0?C.primaryPale:C.rosePale,color:book.available_copies>0?C.primary:C.rose,border:`1px solid ${book.available_copies>0?C.border:"#fecaca"}`,borderRadius:6,padding:"2px 9px",fontSize:11,fontWeight:700}}>
              {book.available_copies}/{book.total_copies} available
            </span>
            <button onClick={()=>setEditingId(book.id)} title="Edit" style={{...ghostBtn,padding:"5px 10px"}}>✏️</button>
            <button onClick={()=>onToggleActive(book)} title={book.is_active?"Deactivate":"Reactivate"} style={{...ghostBtn,padding:"5px 10px",color:book.is_active?C.muted:C.primary}}>
              {book.is_active ? "🚫" : "♻️"}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

// ── Issue / Return tab ───────────────────────────────────────────────────
function IssueTab({ books, issues, students, staffList, actorName, onIssue, onReturn, onMarkLost }) {
  const [bookId, setBookId] = React.useState("");
  const [borrowerType, setBorrowerType] = React.useState("student");
  const [borrowerId, setBorrowerId] = React.useState("");
  const [dueDate, setDueDate] = React.useState(addDays(todayStr(),DEFAULT_LOAN_DAYS));
  const [search, setSearch] = React.useState("");

  const borrowerOptions = borrowerType==="student" ? students : staffList;
  const availableBooks = books.filter(b=>b.is_active && b.available_copies>0);

  const submit = () => {
    if (!bookId || !borrowerId) return;
    const book = books.find(b=>b.id===bookId);
    const borrower = borrowerOptions.find(p=>p.id===borrowerId);
    const borrowerName = borrowerType==="student" ? (borrower.full_name||borrower.name) : borrower.name;
    onIssue({ book, borrowerType, borrowerId, borrowerName, dueDate });
    setBookId(""); setBorrowerId("");
    setDueDate(addDays(todayStr(),DEFAULT_LOAN_DAYS));
  };

  const activeIssues = issues.filter(i=>i.status==="issued").filter(i=>
    !search.trim() || [i.book_title,i.borrower_name].filter(Boolean).some(s=>s.toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <div style={{background:C.white,borderRadius:12,border:`1px solid ${C.border}`,padding:16,display:"flex",flexDirection:"column",gap:10}}>
        <div style={{fontWeight:800,fontSize:14,color:C.text}}>Issue a Book</div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          <select value={bookId} onChange={e=>setBookId(e.target.value)} style={{...inp,flex:2,minWidth:200}}>
            <option value="">Select book…</option>
            {availableBooks.map(b=><option key={b.id} value={b.id}>{b.title} ({b.available_copies} available)</option>)}
          </select>
          <select value={borrowerType} onChange={e=>{setBorrowerType(e.target.value);setBorrowerId("");}} style={inp}>
            <option value="student">Student</option>
            <option value="staff">Staff</option>
          </select>
          <select value={borrowerId} onChange={e=>setBorrowerId(e.target.value)} style={{...inp,flex:1,minWidth:160}}>
            <option value="">Select {borrowerType}…</option>
            {borrowerOptions.map(p=><option key={p.id} value={p.id}>{borrowerType==="student" ? `${p.full_name||p.name} (${p.class||"—"})` : `${p.name} (${p.role})`}</option>)}
          </select>
          <input type="date" value={dueDate} onChange={e=>setDueDate(e.target.value)} style={inp}/>
          <button onClick={submit} disabled={!bookId||!borrowerId} style={btn(bookId&&borrowerId?C.primary:"#9ca3af")}>📤 Issue</button>
        </div>
      </div>

      <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
          <div style={{fontWeight:800,fontSize:14,color:C.text}}>Currently Issued ({activeIssues.length})</div>
          <input placeholder="🔎 Search book / borrower" value={search} onChange={e=>setSearch(e.target.value)} style={{...inp,minWidth:200}}/>
        </div>
        {activeIssues.length===0 && (
          <div style={{background:C.white,borderRadius:12,padding:24,textAlign:"center",color:C.muted,fontSize:13,border:`1px solid ${C.border}`}}>
            Nothing currently issued.
          </div>
        )}
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {activeIssues.map(issue => {
            const overdue = isOverdue(issue);
            return (
              <div key={issue.id} style={{background:overdue?C.rosePale:C.white,border:`1px solid ${overdue?"#fecaca":C.border}`,borderRadius:10,padding:"10px 14px",display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,flexWrap:"wrap"}}>
                <div>
                  <div style={{fontWeight:700,fontSize:13,color:C.text}}>{issue.book_title}</div>
                  <div style={{fontSize:11,color:overdue?C.rose:C.muted,fontWeight:overdue?700:400}}>
                    {issue.borrower_name} ({issue.borrower_type}) · due {fmt(issue.due_date)} {overdue && "· OVERDUE"}
                  </div>
                </div>
                <div style={{display:"flex",gap:6}}>
                  <button onClick={()=>onReturn(issue)} style={btn(C.primary)}>📥 Return</button>
                  <button onClick={()=>onMarkLost(issue)} style={{...ghostBtn,color:C.rose}}>Mark Lost</button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

// ── Loans & History tab ───────────────────────────────────────────────────
function LoansTab({ issues }) {
  const [statusFilter, setStatusFilter] = React.useState("all");
  const filtered = issues.filter(i => {
    if (statusFilter==="all") return true;
    if (statusFilter==="overdue") return isOverdue(i);
    return i.status===statusFilter;
  });
  return (
    <div style={{display:"flex",flexDirection:"column",gap:10}}>
      <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
        {[["all","All"],["issued","Issued"],["overdue","Overdue"],["returned","Returned"],["lost","Lost"]].map(([id,label])=>(
          <button key={id} onClick={()=>setStatusFilter(id)}
            style={{background:statusFilter===id?C.text:C.white,color:statusFilter===id?C.white:C.text,border:`1px solid ${statusFilter===id?C.text:C.border}`,borderRadius:9,padding:"6px 14px",fontWeight:700,fontSize:12,cursor:"pointer"}}>
            {label}
          </button>
        ))}
      </div>
      {filtered.length===0 && (
        <div style={{background:C.white,borderRadius:12,padding:24,textAlign:"center",color:C.muted,fontSize:13,border:`1px solid ${C.border}`}}>
          No records.
        </div>
      )}
      {filtered.map(issue => {
        const overdue = isOverdue(issue);
        return (
          <div key={issue.id} style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:10,padding:"10px 14px",display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,flexWrap:"wrap"}}>
            <div>
              <div style={{fontWeight:700,fontSize:13,color:C.text}}>{issue.book_title}</div>
              <div style={{fontSize:11,color:C.muted}}>{issue.borrower_name} ({issue.borrower_type}) · issued {fmt(issue.issue_date)} · due {fmt(issue.due_date)}{issue.return_date && ` · returned ${fmt(issue.return_date)}`}</div>
            </div>
            {overdue
              ? <span style={{background:C.rosePale,color:C.rose,border:"1px solid #fecaca",borderRadius:6,padding:"2px 9px",fontSize:11,fontWeight:700}}>🔴 Overdue</span>
              : issue.status==="returned"
              ? <span style={{background:"#f0fdf4",color:"#16a34a",border:"1px solid #bbf7d0",borderRadius:6,padding:"2px 9px",fontSize:11,fontWeight:700}}>✅ Returned</span>
              : issue.status==="lost"
              ? <span style={{background:"#f3f4f6",color:C.muted,border:"1px solid #e5e7eb",borderRadius:6,padding:"2px 9px",fontSize:11,fontWeight:700}}>❓ Lost</span>
              : <span style={{background:C.bluePale,color:C.blue,border:"1px solid #bfdbfe",borderRadius:6,padding:"2px 9px",fontSize:11,fontWeight:700}}>📖 Issued</span>}
          </div>
        );
      })}
    </div>
  );
}

// ── Teacher Assigned (librarian) tab ───────────────────────────────────────
function AssignedTab({ librarians }) {
  return (
    <div style={{display:"flex",flexDirection:"column",gap:10}}>
      <div style={{fontSize:12,color:C.muted}}>Whoever holds an active "Library" duty in Staff Responsibilities runs the library day-to-day and automatically gets the Library tab in their Teacher Portal.</div>
      {librarians.length===0 && (
        <div style={{background:C.amberPale,border:`1px solid ${C.amberMid}`,borderRadius:12,padding:16,fontSize:13,color:C.amber}}>
          ⚠️ No one is currently assigned as Librarian. Assign someone via Staff Responsibilities → "+ Assign Responsibility" → type "Library".
        </div>
      )}
      {librarians.map(l => (
        <div key={l.id} style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:10,padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,flexWrap:"wrap"}}>
          <div>
            <div style={{fontWeight:800,fontSize:14,color:C.text}}>📚 {l.staff_name}</div>
            <div style={{fontSize:11,color:C.muted}}>Librarian since {fmt(l.assigned_date)}</div>
          </div>
          {l.acknowledged
            ? <span style={{background:C.bluePale,color:C.blue,border:"1px solid #bfdbfe",borderRadius:6,padding:"2px 9px",fontSize:11,fontWeight:700}}>✅ Acknowledged</span>
            : <span style={{background:C.amberPale,color:C.amber,border:`1px solid ${C.amberMid}`,borderRadius:6,padding:"2px 9px",fontSize:11,fontWeight:700}}>⏳ Pending Ack</span>}
        </div>
      ))}
    </div>
  );
}

// ── Shared manager ──────────────────────────────────────────────────────────
function LibraryManager({ actorName }) {
  const [tab, setTab] = React.useState("catalog");
  const [books, setBooks] = React.useState([]);
  const [issues, setIssues] = React.useState([]);
  const [students, setStudents] = React.useState([]);
  const [staffList, setStaffList] = React.useState([]);
  const [librarians, setLibrarians] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [toast, setToast] = React.useState(null);

  const showToast = (msg,ok=true) => { setToast({msg,ok}); setTimeout(()=>setToast(null),3000); };

  const load = React.useCallback(async () => {
    setLoading(true);
    const [{data:bookRows},{data:issueRows},{data:studentRows},{data:staffRows},{data:libRows}] = await Promise.all([
      supabase.from("library_books").select("*").order("title"),
      supabase.from("library_issues").select("*").order("issue_date",{ascending:false}),
      supabase.from("students").select("id,full_name,class").order("full_name"),
      supabase.from("staff").select("id,name,role").eq("status","Active").order("name"),
      supabase.from("staff_responsibilities").select("*").eq("responsibility_type","Library").eq("is_active",true).order("assigned_date",{ascending:false}),
    ]);
    setBooks(bookRows||[]);
    setIssues(issueRows||[]);
    setStudents(studentRows||[]);
    setStaffList(staffRows||[]);
    setLibrarians(libRows||[]);
    setLoading(false);
  }, []);

  React.useEffect(()=>{ load(); }, [load]);

  const addBook = async (form) => {
    const { data, error } = await supabase.from("library_books").insert({
      title:form.title, author:form.author||null, category:form.category||null, isbn:form.isbn||null,
      total_copies:form.total_copies, available_copies:form.total_copies, shelf_location:form.shelf_location||null,
    }).select().single();
    if (error) { showToast("Error: "+error.message, false); return; }
    setBooks(p=>[...p,data].sort((a,b)=>a.title.localeCompare(b.title)));
    showToast("Book added to catalog.");
  };

  const updateBook = async (id, form) => {
    const existing = books.find(b=>b.id===id);
    const issuedOut = existing.total_copies - existing.available_copies;
    const newAvailable = Math.max(0, form.total_copies - issuedOut);
    const payload = { title:form.title, author:form.author||null, category:form.category||null, isbn:form.isbn||null,
      total_copies:form.total_copies, available_copies:newAvailable, shelf_location:form.shelf_location||null };
    const { error } = await supabase.from("library_books").update(payload).eq("id",id);
    if (error) { showToast("Error: "+error.message, false); return; }
    setBooks(p=>p.map(b=>b.id===id?{...b,...payload}:b));
    showToast("Book updated.");
  };

  const toggleActive = async (book) => {
    const { error } = await supabase.from("library_books").update({is_active:!book.is_active}).eq("id",book.id);
    if (error) { showToast("Error: "+error.message, false); return; }
    setBooks(p=>p.map(b=>b.id===book.id?{...b,is_active:!b.is_active}:b));
  };

  const issueBook = async ({ book, borrowerType, borrowerId, borrowerName, dueDate }) => {
    if (book.available_copies<=0) { showToast("No copies available.", false); return; }
    const { data, error } = await supabase.from("library_issues").insert({
      book_id:book.id, book_title:book.title, borrower_type:borrowerType, borrower_id:borrowerId, borrower_name:borrowerName,
      due_date:dueDate, status:"issued", issued_by_name:actorName,
    }).select().single();
    if (error) { showToast("Error: "+error.message, false); return; }
    await supabase.from("library_books").update({available_copies:book.available_copies-1}).eq("id",book.id);
    setIssues(p=>[data,...p]);
    setBooks(p=>p.map(b=>b.id===book.id?{...b,available_copies:b.available_copies-1}:b));
    showToast(`Issued "${book.title}" to ${borrowerName}.`);
  };

  const returnBook = async (issue) => {
    const { error } = await supabase.from("library_issues").update({status:"returned",return_date:todayStr()}).eq("id",issue.id);
    if (error) { showToast("Error: "+error.message, false); return; }
    const book = books.find(b=>b.id===issue.book_id);
    if (book) {
      await supabase.from("library_books").update({available_copies:Math.min(book.total_copies,book.available_copies+1)}).eq("id",book.id);
      setBooks(p=>p.map(b=>b.id===book.id?{...b,available_copies:Math.min(b.total_copies,b.available_copies+1)}:b));
    }
    setIssues(p=>p.map(i=>i.id===issue.id?{...i,status:"returned",return_date:todayStr()}:i));
    showToast("Book returned.");
  };

  const markLost = async (issue) => {
    if (!window.confirm(`Mark "${issue.book_title}" (${issue.borrower_name}) as lost? This permanently removes a copy from the catalog.`)) return;
    const { error } = await supabase.from("library_issues").update({status:"lost"}).eq("id",issue.id);
    if (error) { showToast("Error: "+error.message, false); return; }
    const book = books.find(b=>b.id===issue.book_id);
    if (book) {
      await supabase.from("library_books").update({total_copies:Math.max(0,book.total_copies-1)}).eq("id",book.id);
      setBooks(p=>p.map(b=>b.id===book.id?{...b,total_copies:Math.max(0,b.total_copies-1)}:b));
    }
    setIssues(p=>p.map(i=>i.id===issue.id?{...i,status:"lost"}:i));
    showToast("Marked as lost.");
  };

  const totalBooks = books.reduce((s,b)=>s+b.total_copies,0);
  const availableBooks = books.reduce((s,b)=>s+b.available_copies,0);
  const issuedCount = issues.filter(i=>i.status==="issued").length;
  const overdueCount = issues.filter(isOverdue).length;

  const TABS = [
    {id:"catalog", label:"📚 Catalog"},
    {id:"issue",   label:"🔄 Issue / Return"},
    {id:"loans",   label:"📋 Loans & History"},
    {id:"assigned",label:"🧑‍🏫 Teacher Assigned"},
  ];

  return (
    <div style={{display:"flex",flexDirection:"column",gap:16}}>
      <Toast toast={toast}/>
      <div style={{background:C.white,borderRadius:14,padding:"18px 22px",border:`1px solid ${C.border}`,boxShadow:`0 2px 10px ${C.shadow}`}}>
        <div style={{fontWeight:900,fontSize:17,color:C.primary,marginBottom:4}}>📚 Library</div>
        <div style={{fontSize:12,color:C.muted,marginBottom:14}}>Catalog, issue/return, and who's running the library right now.</div>
        <div style={{display:"flex",gap:12,flexWrap:"wrap",marginBottom:14}}>
          <StatCard icon="📘" label="Total Copies" val={totalBooks} col={C.blue} bg={C.bluePale}/>
          <StatCard icon="✅" label="Available Now" val={availableBooks} col={C.primary} bg={C.primaryPale}/>
          <StatCard icon="📖" label="Currently Issued" val={issuedCount} col={C.amber} bg={C.amberPale}/>
          <StatCard icon="🔴" label="Overdue" val={overdueCount} col={C.rose} bg={C.rosePale}/>
        </div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          {TABS.map(t=>(
            <button key={t.id} onClick={()=>setTab(t.id)}
              style={{background:tab===t.id?C.text:C.white,color:tab===t.id?C.white:C.text,border:`1px solid ${tab===t.id?C.text:C.border}`,borderRadius:9,padding:"7px 14px",fontWeight:700,fontSize:12,cursor:"pointer"}}>
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div style={{color:C.muted,fontSize:13,padding:16}}>Loading…</div>
      ) : (
        <>
          {tab==="catalog" && <CatalogTab books={books} onAdd={addBook} onUpdate={updateBook} onToggleActive={toggleActive}/>}
          {tab==="issue" && <IssueTab books={books} issues={issues} students={students} staffList={staffList} actorName={actorName} onIssue={issueBook} onReturn={returnBook} onMarkLost={markLost}/>}
          {tab==="loans" && <LoansTab issues={issues}/>}
          {tab==="assigned" && <AssignedTab librarians={librarians}/>}
        </>
      )}
    </div>
  );
}

export function LibraryAdmin() {
  return <LibraryManager actorName="Admin"/>;
}

export function LibraryTab({ teacher }) {
  return <LibraryManager actorName={teacher.name}/>;
}
